export * from './delete-projekt-status.component';
export * from './delete-projekt-status.component.module';